import { render, staticRenderFns } from "./AffiliateStatement.vue?vue&type=template&id=7580bf74&scoped=true&"
import script from "./AffiliateStatement.vue?vue&type=script&lang=js&"
export * from "./AffiliateStatement.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateStatement.vue?vue&type=style&index=0&id=7580bf74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7580bf74",
  null
  
)

export default component.exports